import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {IndexedDbService} from '../../../workbench/shared/services/indexed-db.service';
import {BlobId} from '@webmate-web-core/shared/types/ids';

export interface BlobUrlResult {
    url: string;
    blobId: BlobId | undefined;
}

@Injectable({ providedIn: 'root' })
export class BlobUrlService {

    constructor(private indexedDbService: IndexedDbService) {}

    loadAsObjectUrl(url: string): Observable<BlobUrlResult> {
        let blobId: BlobId | undefined;
        let fetchFailed = false;
        return this.indexedDbService.addResourceAsBlob(url).pipe(
            catchError(() => {
                fetchFailed = true;
                return of(undefined);
            }),
            switchMap((id) => {
                if (fetchFailed || !id) {
                    return of(undefined);
                }
                blobId = id;
                return this.indexedDbService.getBlob(blobId).pipe(
                    catchError((): Observable<undefined> => of(undefined))
                );
            }),
            switchMap((blob): Observable<BlobUrlResult> => {
                if (!blob) {
                    return of({ url, blobId: undefined });
                }
                return of({
                    url: URL.createObjectURL(blob),
                    blobId,
                });
            })
        );
    }

    removeBlob(blobId: string): Observable<void> {
        return this.indexedDbService.removeBlob(blobId);
    }

    revokeObjectUrl(url?: string): void {
        if (url?.startsWith('blob:')) {
            URL.revokeObjectURL(url);
        }
    }

    releaseBlobUrl(blobId?: BlobId, url?: string): Observable<void> {
        this.revokeObjectUrl(url);
        if (!blobId) {
            return of(undefined);
        }
        return this.removeBlob(blobId).pipe(catchError(() => of(undefined)));
    }
}
